// libraries.
import { useNavigate } from 'react-router-dom';

// components.
import { ButtonSidebar } from '@shared';
import { IconCentral } from '@assets/icons';

export const ButtonOrchestrator = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/orchestrator-pricing-committee/list-opc');
  };

  return (
    <ButtonSidebar
      icon={<IconCentral fill="white" />}
      text="La Central"
      onClick={handleClick}
    />
  );
};
